import Vue from 'vue';
import Vuex from 'vuex';
import tournament from './modules/tournament';
import webApp from './modules/webApp';
import deals from './modules/deals';
import players from './modules/players';
import ranks from './modules/ranks';
import matches from './modules/matches';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        tournament: tournament,
        webApp: webApp,
        deals: deals,
        players: players,
        matches: matches,
        ranks: ranks
    }
});